import CapeLazy from "./CapeLazy";
import CapeCalendar from "./CapeCalendar";
import select2 from "select2";
import News from "./News";
import Sliders from "./Sliders";
import Videos from "./Videos";
import Events from "./Events";
import MicroModal from 'micromodal';

export default class InitJS {
    constructor() {
    }

    init(origin = 'barba') {
        MicroModal.init({
            disableScroll: true,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });

        let $eventListCalendar = $('#event-list-calendar');

        if ($eventListCalendar.length) {
            let elementPosition = $eventListCalendar.offset();

            if ($(window).scrollTop() > 40) {
                document.documentElement.style.setProperty('--calendar-top', ($(window).scrollTop() - 60) + 'px');
            } else {
                document.documentElement.style.setProperty('--calendar-top', 0);
            }

            $(window).scroll(function () {

                if ($(window).scrollTop() > 40) {
                    document.documentElement.style.setProperty('--calendar-top', ($(window).scrollTop() - 60) + 'px');
                } else {
                    document.documentElement.style.setProperty('--calendar-top', 0);
                }
            });
        }

        select2(window.$);
        $(`select`).select2({
            minimumResultsForSearch: 100,
            width: 'resolve'
        });

        $('.event-list-filters__filter').off('change').on('change', () => {
            $('.event-list-filters').submit();
        });

        if (origin === 'barba') {
            new CapeCalendar();
        }

        new CapeLazy();
        new News();
        new Sliders();
        new Videos();
        new Events();


        var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

        if ($('#map').length) {
            mapboxgl.accessToken = 'pk.eyJ1IjoiYXltYW5lLWJrcCIsImEiOiJjazQ5cjBjcGowN2ZhM2xwYmI0NXYycWQyIn0.YiLvzXD47F0fGjtIQFXmCg';
            let map = new mapboxgl.Map({
                center: [6.097680, 49.845390],
                zoom: 16,
                container: 'map',
                style: 'mapbox://styles/mapbox/light-v10'
            });

            var marker = new mapboxgl.Marker()
                .setLngLat([6.097680, 49.845390])
                .addTo(map);
        }
    }

}
